/**
 * Feature flags configuration
 *
 * Each feature can have:
 * - enabled: Boolean to enable/disable the feature globally
 * - allowedEmailSuffixes: Optional array of email suffixes (domains) that are allowed to access the feature
 *   Example: ['company.com', 'dev.company.com']
 *   Note: The @ prefix is automatically added, so just specify the domain
 *
 * When allowedEmailSuffixes is provided, the feature will only be enabled for users
 * whose email ends with one of the specified suffixes.
 */

export interface FeatureConfig {
  enabled: boolean
  allowedEmailSuffixes?: string[]
}

export interface FeaturesConfig {
  transactionApprovalFlow: FeatureConfig
  userSettingsInitiatorPermissions: FeatureConfig
  // Add more feature flags here as needed
  depositPromoCode: FeatureConfig
  withdrawPromoCode: FeatureConfig
  kingdomCoinTradingChart: FeatureConfig
  merchantFeatureOauth: FeatureConfig
}

export const featuresConfig: FeaturesConfig = {
  transactionApprovalFlow: {
    enabled: true,
    allowedEmailSuffixes: []
  },
  userSettingsInitiatorPermissions: {
    enabled: true,
    allowedEmailSuffixes: []
  },
  depositPromoCode: {
    enabled: true,
    allowedEmailSuffixes: []
  },
  withdrawPromoCode: {
    enabled: true,
    allowedEmailSuffixes: []
  },
  kingdomCoinTradingChart: {
    enabled: true,
    allowedEmailSuffixes: ['mmfintech.io', 'thekingdombank.com']
  },
  merchantFeatureOauth: {
    enabled: true,
    allowedEmailSuffixes: []
  }
}
